module.exports = __webpack_public_path__ + "img/15.07e446f9.jpg";